"use client"

import * as React from "react"
import { SelectInput } from "@ui/forms/inputs/select-input"
import { Button } from "@ui/shad"
import { cn } from "@ui/utils"

export type SelectOption = {
  value: string
  label: string | React.ReactNode
  icon?: React.ReactNode
}

export interface BadgeSelectProps {
  id: string
  value: string
  onValueChange: (value: string) => void
  disabled?: boolean
  options: SelectOption[]
  children?: React.ReactNode
  className?: string
  placeholder?: string
}

export function BadgeInputSelect({
  id,
  children,
  options,
  disabled = false,
  value,
  onValueChange,
  className,
  placeholder = "Select an option",
}: BadgeSelectProps) {
  const hasValue = value !== "" && value !== "none"

  return (
    <SelectInput
      id={id}
      options={options}
      value={value}
      onChange={(value: string) => onValueChange(value)}
      placeholder={placeholder}
      disabled={disabled}
      className="space-y-0"
      contentProps={{ className: "min-w-40" }}
      triggerButton={
        <Button
          variant="outline"
          className={cn(
            `gap-4 ${hasValue ? "default" : "border-dashed"} flex h-fit w-fit max-w-72 items-center justify-end px-2`,
            className
          )}
          size="lg"
          disabled={disabled}
          type="button"
        >
          {children}
        </Button>
      }
    />
  )
}
